import React from 'react';

const PROFILE_FIELDS = [
  'first_name', 'last_name', 'profile_picture_url', 'birthdate',
  'high_school_name', 'high_school_grad_year', 'intended_major',
  'sat_score', 'act_score', 'gpa', 'phone', 'gender', 'ethnicity',
  'city', 'state', 'postal_code', 'first_gen', 'student_type', 'interests',
];

const calculateProfileStrength = (user) => {
  if (!user) return 0;
  const filled = PROFILE_FIELDS.filter((field) => {
    const val = user[field];
    if (val === null || val === undefined || val === '') return false;
    if (Array.isArray(val) && val.length === 0) return false;
    return true;
  });
  return Math.round((filled.length / PROFILE_FIELDS.length) * 100);
};

const ComingSoonBadge = () => (
  <div className="relative group inline-block">
    <span className="text-xs font-medium px-2 py-0.5 rounded bg-gray-100 text-gray-400 cursor-default select-none">
      Soon
    </span>
    <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-2 py-1 text-xs text-white bg-gray-800 rounded whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-10">
      Coming Soon
    </div>
  </div>
);

const MetricsRow = ({ user, savedCollegesCount }) => {
  const profileStrength = calculateProfileStrength(user);
  const collegeIndex = savedCollegesCount ?? 0;

  const metrics = [
    {
      label: 'Profile Strength',
      value: `${profileStrength}%`,
      comingSoon: false,
      testId: 'metric-profile-strength',
    },
    {
      label: 'Major Fit Score',
      value: '--',
      comingSoon: true,
      testId: 'metric-major-fit',
    },
    {
      label: 'Scholarship Fit Score',
      value: '--',
      comingSoon: true,
      testId: 'metric-scholarship-fit',
    },
    {
      label: 'College Interest Index',
      value: collegeIndex,
      comingSoon: false,
      testId: 'metric-college-index',
    },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-testid="metrics-row">
      {metrics.map((metric) => (
        <div
          key={metric.label}
          data-testid={metric.testId}
          className="bg-white rounded-xl p-5 shadow-sm border border-gray-100"
        >
          <div className="text-sm text-gray-500 mb-2">{metric.label}</div>
          <div className="flex items-center gap-2">
            <div className="text-3xl font-bold text-gray-900">{metric.value}</div>
            {metric.comingSoon && <ComingSoonBadge />}
          </div>
        </div>
      ))}
    </div>
  );
};

export default MetricsRow;
